/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import logoCT from "assets/images/logo-ct-dark.png";

function DefaultFooter() {
  const date = new Date().getFullYear();

  return (
    <MKBox component="footer">
      <Container>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{ maxWidth: "lg", mx: "auto" }}
        >
          <Grid item xs={12} md={6} sx={{ mb: 3 }}>
            <MKBox>
              <Link to="/">
                <MKBox component="img" src={logoCT} alt="Willy Woef" maxWidth="2rem" mb={2} />
              </Link>
              <MKTypography variant="h6">Willy Woef</MKTypography>
            </MKBox>
          </Grid>

          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <MKTypography
              display="block"
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              mb={1}
            >
              Contact
            </MKTypography>
            <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
              <MKBox component="li" p={0} m={0} lineHeight={1.25}>
                <MKTypography
                  component="a"
                  href="mailto:info@willywoef.nl"
                  target="_blank"
                  rel="noreferrer"
                  variant="button"
                  fontWeight="regular"
                >
                  info@willywoef.nl
                </MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <MKTypography
              display="block"
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              mb={1}
            >
              Voorwaarden
            </MKTypography>
            <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
              <MKBox component="li" p={0} m={0} lineHeight={1.25}>
                <MKTypography
                  component="a"
                  href="/algemene-voorwaarden"
                  target="_blank"
                  rel="noreferrer"
                  variant="button"
                  fontWeight="regular"
                  textTransform="capitalize"
                >
                  Algemene voorwaarden
                </MKTypography>
              </MKBox>
              <MKBox component="li" p={0} m={0} lineHeight={1.25}>
                <MKTypography
                  component="a"
                  href="/privacybeleid"
                  target="_blank"
                  rel="noreferrer"
                  variant="button"
                  fontWeight="regular"
                  textTransform="capitalize"
                >
                  Privacybeleid
                </MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center", my: 3 }}>
            <MKTypography variant="button" color="text.secondary">
              Alle rechten voorbehouden. Copyright &copy; {date} Willy Woef.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {};

export default DefaultFooter;
